export class ServiceConfigurationList {
    intServiceTripID: number;
}
export class OrganizationEntityMaster
{
  intOrganizationEntityID:number;
}

export class RouteMaster
{
  intRouteID:number;
}
export class ServiceTagMaster
{
  intServiceTagID:number;
}
export class StationMaster
{
  intStationID:number;
}
export class ServiceTripDetails
{
  intActionType :number;
  intServiceTripID :number;
  strServiceTripNo :string;
  intOrganizationEntityID :number;
  intFromStationID :number;
  intToStationID :number;
  strVia :string;
  strRouteID :string;
  intParentRouteID :number;
  strScheduleNo :string;
  tmDepartureTime :string;
  tmArrivalTime :string;
  intOperationalDaysID :number;
  tmDurationTime :string;
  fltTotalKM : number;
  bAllowCurrentBooking : boolean;
  bAllowRefundOnCancel : boolean;
  strServiceAvailableDaysID :string;
  strPlatformID :string;
  intServiceTagID :number;
  dteEffectiveFrom :string;
  dteEffectiveTo :string;
  bActive : boolean;
  intUserID : number;
}
export class VehicleType
{
  intVehicleTypeID:number;
}
export class ServiceType
{
  intServiceTypeID:number;
}
export class QuotaMaster
{
  intQuotaID:number;
}
export class BusLayoutMaster
{
  intBusLayoutID:number;
}
export class RouteStationMasterFilter
{
  intRouteID:number;
}
export class ServiceTripStationFilterModel
{
  intServiceTripID:number;
}

